<i class="fa-regular fa-magnifying-glass search-icon"></i>
<input #input type="text" [placeholder]="$placeholder() ?? ''" [attr.aria-label]="$ariaLabel() ?? $placeholder()" [value]="$displayValue()" [disabled]="$effectiveDisabled()" [class.ng-invalid]="$invalid()" (input)="onInput($event)" (blur)="onBlur()">
